import { render, staticRenderFns } from "./acceptedOrdersItem.vue?vue&type=template&id=04965798"
import script from "./acceptedOrdersItem.vue?vue&type=script&lang=js"
export * from "./acceptedOrdersItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports